import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { BranchesComponent } from './branches.component';
import { CreateNewBranchComponent } from './create-new-branch/create-new-branch.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NiceSelectModule } from "ng-nice-select";
import { BranchTemplateComponent } from './branch-template/branch-template.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@teem/app/core/core.module';
import { FilePondModule, registerPlugin } from 'ngx-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation/dist/filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop/dist/filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize/dist/filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform/dist/filepond-plugin-image-transform';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit';
// import { OtoTabComponent } from '@teem/store-module/components/product-information/components/oto-tab/oto-tab.component';

const routes: Routes = [
  {
    path: '',
    component: BranchesComponent,
  },
  {
    path: 'create-new-branch',
    component: CreateNewBranchComponent,
  },
];

registerPlugin(
  FilePondPluginFileValidateType,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginImageEdit
);

@NgModule({
  declarations: [
    BranchesComponent,
    CreateNewBranchComponent,
    // OtoTabComponent,
    BranchTemplateComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    NgbModule,
    NiceSelectModule,
    ReactiveFormsModule,
    CoreModule,
    FilePondModule,
  ],
  exports: [
    RouterModule, 
    BranchesComponent
  ],
})
export class BranchesModule {}